import styled, { css, keyframes } from 'styled-components'
import { Flex } from 'rebass'
import { style, height, fontWeight, lineHeight } from 'styled-system'

const animationName = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    display: none;
    height: 0px;
  }
`

const animation = () =>
  css`
    ${animationName} 0.55s forwards ease-out;
  `

const requiredColor = style({
  prop: 'requiredColor',
  cssProperty: 'color',
  key: 'colors'
})

const Label = styled(Flex).attrs({
  as: 'label'
})`
  ${height}
  ${lineHeight}
  ${fontWeight}
  ${props => props.noLineHeight
      ? css`
        line-height: unset;
      `
      : css`
        line-height: 1.3;
      `}
  ${props =>
    props.required
      ? css`
          :after {
            content: ' *';
            margin-left: 3px;
            ${requiredColor}
          }
        `
      : ''}
  ${props =>
    props.animated
      ? css`
          animation: ${animation};
        `
      : ''};
`

Label.defaultProps = {
  // lineHeight: '1.3',
  fontSize: 'm',
  requiredColor: 'rgba(235, 81, 96, 0.8)',
  fontWeight: 2,
  alignItems: 'center'
}

export default Label
